module.exports = __webpack_public_path__ + "static/media/ufe2-logo.b643d355.png";